import { clsx } from 'clsx';

import { Box } from '@highlight-cp/core-ui';

import classes from './svg-icons.module.css';

enum ICON_CLASSES {
  LIGHTBULB = 'lightbulb',
  SKIP = 'skip',
  PHOTOS = 'photos',
}

interface SvgIconProps {
  icon: ICON_CLASSES;
  className?: string;
}

const SvgIcon = ({ icon, className }: SvgIconProps) => (
  <Box className={clsx(classes.icon, classes[icon], className)} />
);

const Lightbulb = (props: Omit<SvgIconProps, 'icon'>) => (
  <SvgIcon icon={ICON_CLASSES.LIGHTBULB} {...props} />
);

const Skip = (props: Omit<SvgIconProps, 'icon'>) => <SvgIcon icon={ICON_CLASSES.SKIP} {...props} />;

const Photos = (props: Omit<SvgIconProps, 'icon'>) => (
  <SvgIcon icon={ICON_CLASSES.PHOTOS} {...props} />
);

const FileDropImage = ({ className }: { className?: string }) => (
  <Box className={clsx(classes.fileDropImage, className)} aria-hidden />
);

export default {
  Lightbulb,
  Skip,
  Photos,
  FileDropImage,
};
